import "./coupons_card.css";
import { MdOutlineContentCopy } from "react-icons/md";
import toast from "react-hot-toast";
import moment from "moment";
import Button from "antd/lib/button";
import dayjs from "dayjs";

const CouponsCard = ({ data, setUpdateModal, updateCouponController }) => {
  return (
    <>
      <div className="coupons_card">
        {/* code */}
        <div>
          <span>Code</span>
          <div>
            <h3>{data.code}</h3>
            <MdOutlineContentCopy
              style={{ cursor: "pointer" }}
              onClick={() => {
                toast.success("Copied successfully");
                navigator.clipboard.writeText(data.code);
              }}
            />
          </div>
        </div>
        {/* valueType */}
        <div>
          <span>Discount Type</span>
          <h3>Percentage</h3>
        </div>
        {/* amount */}
        <div>
          <span>Discount Value</span>
          <h3>{data.amount}%</h3>
        </div>
        {/* startDate */}
        <div>
          <span>Start Date</span>
          <h3>
            {data.startDate
              ? moment(data.startDate).format("YYYY-MM-DD")
              : "-----------"}
          </h3>
        </div>
        {/* endDate */}
        <div>
          <span>End Date</span>
          <h3>
            {data.endDate
              ? moment(data.endDate).format("YYYY-MM-DD")
              : "-----------"}
          </h3>
        </div>
        {/* usageLimit */}
        <div>
          <span>Usage Limit</span>
          <h3 style={{ display: "flex", alignItems: "center" }}>
            {data.usageLimit ? data.usageLimit : "-----------"}
          </h3>
        </div>
        {/* description */}
        <div>
          <span>Description</span>
          <h3 style={{ display: "flex", alignItems: "center" }}>
            {data.description?.length > 0 ? data.description : "-----------"}
          </h3>
        </div>
        {/* courses */}
        <div>
          <span>Courses</span>
          <h3 style={{ display: "flex", alignItems: "center" }}>
            {data.courses?.length > 0
              ? data.courses?.map((item, index) => {
                  return `${item.name}${
                    index != data.courses.length - 1 ? " , " : ""
                  }`;
                })
              : "-----------"}
          </h3>
        </div>
        {/* isActive */}
        <div>
          <span>Status</span>
          <h3
            style={
              data.isActive
                ? { color: "green", display: "flex", alignItems: "center" }
                : { color: "red", display: "flex", alignItems: "center" }
            }
          >
            {data.isActive ? "Active" : "Deactive"}
          </h3>
        </div>
        <Button
          onClick={() => {
            setUpdateModal(true);
            updateCouponController.setFieldValue("coupon_id", data.id);
            updateCouponController.setFieldValue("code", data.code);
            if (data.startDate) {
              updateCouponController.setFieldValue(
                "startDate",
                dayjs(
                  moment(data.startDate).format("YYYY-MM-DD"),
                  "YYYY-MM-DD",
                ),
              );
            }
            if (data.endDate) {
              updateCouponController.setFieldValue(
                "endDate",
                dayjs(moment(data.endDate).format("YYYY-MM-DD"), "YYYY-MM-DD"),
              );
            }
            if (data.usageLimit) {
              updateCouponController.setFieldValue(
                "usageLimit",
                data.usageLimit.toString(),
              );
            }
            if (data.courses?.length > 0) {
              updateCouponController.setFieldValue(
                "courseIds",
                data.courses?.map((item) => {
                  return item.id;
                }),
              );
            }
            updateCouponController.setFieldValue("isActive", data.isActive);
            if (data.description?.length > 0) {
              updateCouponController.setFieldValue(
                "description",
                data.description,
              );
            }
          }}
        >
          Update coupon
        </Button>
      </div>
    </>
  );
};

export default CouponsCard;
